/**
 * If you want to change the years shown in the CCDC app, change the settings here.
 * Please note that you might also need to change the wave_id set in two files:
 * 1. src/components/Covid/ProvidersByQualityRating.js
 * 2. src/components/Covid/ProvidersBySettingType.js
 * In both of these cases, the wave_id is set to '2020 Annual Submission' at the moment.
 * You might add a new key to years to manage this, or perhaps you could update the query to search by query by qris_code instead, which might be easier to maintain instead of having to worry about wave_id names.
 */
export const years = {
  rdsCovidWave: 2020,
  rdsWave: 2021,
  inReview: 2020,
  covidFromMonthYear: 'December 2019',
  covidToMonthYear: 'December 2020',
};

export default years;
